/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('offersPanelOccupancy', {
    templateUrl: 'app/components/offers/panel/occupancy/Occupancy.html',
    controller: PanelOccupancy,
    bindings: {
      occupancy: '<',
      onClick: '&'
    }
  });

// eslint-disable-next-line
function PanelOccupancy(PanelObserver, ConfigBookingEngine, ConfigHotel, PROPERTY_TYPE, $translate) {
  var $this = this;
  $this.PanelObserver = PanelObserver;
  $this.PROPERTY_TYPE = PROPERTY_TYPE;
  $this.ConfigHotel = ConfigHotel;
  $this.$translate = $translate;
  $this.maxAvailableRooms = ConfigBookingEngine.getMaxAvailableRooms();
  $this.propertyType = ConfigHotel.getPropertyType();
}

PanelOccupancy.prototype = {
  $onInit: function () {
    this.occupancy = angular.copy(this.occupancy);
    this.PanelObserver.setOccupancy(this.occupancy);
  },

  $onChanges: function () {
    this.PanelObserver.setOccupancy(null);
  },

  handleClick: function () {
    this.onClick();
  },

  handleChange: function () {
    this.PanelObserver.setOccupancy(this.occupancy);
  },

  getPanelTitle: function () {
    switch (this.propertyType) {
      case this.PROPERTY_TYPE.ROOMS:
        return this.$translate.instant('offers.panel.occupancy.TITLE_ROOMS');
      case this.PROPERTY_TYPE.APARTMENTS:
        return this.$translate.instant('offers.panel.occupancy.TITLE_APARTMENTS');
      case this.PROPERTY_TYPE.COTTAGES:
        return this.$translate.instant('offers.panel.occupancy.TITLE_COTTAGES');
      default:
        return this.$translate.instant('offers.panel.occupancy.TITLE_ROOMS');
    }
  },

  getNumberOfPersons: function () {
    var sum = 0;
    for (var i = 0; i < this.occupancy.length; i++) {
      sum += this.occupancy[i].count;
      sum += this.occupancy[i].cat1;
      sum += this.occupancy[i].cat2;
      sum += this.occupancy[i].cat3;
    }
    return sum;
  },

  getNumberOfRooms: function () {
    return this.occupancy.length;
  },

  getPersonTranslation: function (count) {
    var translations = this.getPersonDeclination();

    if (count in translations) {
      return translations[count].replace('%d', count);
    }
    return translations['-1'].replace('%d', count);
  },

  getPersonDeclination: function () {
    return {
      1: this.$translate.instant('offers.panel.occupancy.ONE_PERSON'),
      2: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_PEOPLE'),
      3: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_PEOPLE'),
      4: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_PEOPLE'),
      '-1': this.$translate.instant('offers.panel.occupancy.FIVE_AND_MORE_PEOPLE')
    };
  },

  addRoom: function () {
    this.occupancy.push({count: 1, cat1: 0, cat2: 0, cat3: 0});
  },

  removeRoom: function (index) {
    if (this.occupancy.length > 1) {
      this.occupancy.splice(index, 1);
    }
  },

  updatePeopleCount: function (roomId, count, cat1, cat2, cat3) {
    this.occupancy[roomId].count = count;
    this.occupancy[roomId].cat1 = cat1;
    this.occupancy[roomId].cat2 = cat2;
    this.occupancy[roomId].cat3 = cat3;
  },

  getRoomTranslation: function (count) {
    var translations;

    switch (this.propertyType) {
      case this.PROPERTY_TYPE.ROOMS:
        translations = this.getRoomDeclination();
        break;
      case this.PROPERTY_TYPE.APARTMENTS:
        translations = this.getApartmentDeclination();
        break;
      case this.PROPERTY_TYPE.COTTAGES:
        translations = this.getCottageDeclination();
        break;
      default:
        translations = this.getRoomDeclination();
        break;
    }

    if (count in translations) {
      return translations[count].replace('%d', count);
    }
    return translations['-1'].replace('%d', count);
  },

  getRoomDeclination: function () {
    return {
      1: this.$translate.instant('offers.panel.occupancy.ONE_ROOM'),
      2: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_ROOMS'),
      3: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_ROOMS'),
      4: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_ROOMS'),
      '-1': this.$translate.instant('offers.panel.occupancy.FIVE_AND_MORE_ROOMS')
    };
  },

  getApartmentDeclination: function () {
    return {
      1: this.$translate.instant('offers.panel.occupancy.ONE_APARTMENT'),
      2: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_APARTMENTS'),
      3: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_APARTMENTS'),
      4: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_APARTMENTS'),
      '-1': this.$translate.instant('offers.panel.occupancy.FIVE_AND_MORE_APARTMENTS')
    };
  },

  getCottageDeclination: function () {
    return {
      1: this.$translate.instant('offers.panel.occupancy.ONE_COTTAGE'),
      2: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_COTTAGES'),
      3: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_COTTAGES'),
      4: this.$translate.instant('offers.panel.occupancy.TWO_TO_FOUR_COTTAGES'),
      '-1': this.$translate.instant('offers.panel.occupancy.FIVE_AND_MORE_COTTAGES')
    };
  }
};
